// extracted by mini-css-extract-plugin
export default {"container":"LoginLayout_container__cHEd5","main":"LoginLayout_main__ZMs2+","footer":"LoginLayout_footer__o823t"};